<template>
  <b-container class="areas-list" fluid>
    <div class="w-100 text-center mb-3 d-none">
      <router-link :to="'/areas-map'">
        <b-button class="mt-5" size="lg">Show Forests Map</b-button>
      </router-link>
    </div>
    <div class="row">
      <div id="areas-filter-buttons" class="col-md-6 col-lg-3">
        <b-btn v-if="this.getWeb2ActiveAccount && this.getWeb2ActiveAccount.role.name === 'Administrator'"
               class="mr-2" @click="showAllAreas">All forests
        </b-btn>
        <b-btn v-if="this.getWeb2ActiveAccount && this.getWeb2ActiveAccount.role.name === 'Administrator'"
               class="mr-2" @click="showMyAreas">My forests
        </b-btn>
        <b-btn v-if="this.getWeb2ActiveAccount && this.getWeb2ActiveAccount.role.name === 'Administrator'"
               id="add-forest-btn" variant="primary" @click="$bvModal.show('add-forest-modal')">
          <b-icon-plus></b-icon-plus>
          Add forest
        </b-btn>
      </div>
      <div id="areas-search-group" class="col-md-6 col-lg-3 offset-lg-6">

        <b-input-group>
          <b-form-input
          v-model="searchTable"
          placeholder="Type here"
          required

          type="text"
          @change="search()"
        ></b-form-input>
          <b-input-group-append>
            <b-button text="Button" variant="primary" @click="search()">Search</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div>
    <div v-if="!areasTable" class="d-flex justify-content-center mt-5">
      <div class="spinner-border" role="status" style="width: 3rem; height: 3rem;">
        <span class="visually-hidden"></span>
      </div>
    </div>
    <table id="areas-datatables" class="table table-striped table-bordered mb-3" style="width:100%;">
    </table>

    <b-modal
      v-if="this.getWeb2ActiveAccount && this.getWeb2ActiveAccount.role.name === 'Administrator'"
      id="add-forest-modal"
      title="Add a new forest"
      size="xl"
      scrollable
      hide-footer
      body-class="add-forest-modal-body"
    >
      <AreaAddComponent embedded />
    </b-modal>
  </b-container>
</template>

<script>
import "datatables.net/js/jquery.dataTables";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-fixedheader-bs4/js/fixedHeader.bootstrap4";
import "datatables.net-responsive-bs4/js/responsive.bootstrap4";
import "datatables.net-scroller-bs4/js/scroller.bootstrap4";

import Area from "../../api/Area";
import AreaAddComponent from "../../components/Admin/AreaAddComponent";
import { mapActions, mapGetters } from "vuex";
// import moment from 'moment';
import Config from "../../api/Config";
import TokenStorage from "../../utils/TokenStorage";
import Header from "../../utils/Header";
// import Stats from '../../api/Stats'
import $ from "jquery";
import Swal from "sweetalert2";
import createPageTourMixin from "../../mixins/pageTour";

const escapeHtml = (text) => String(text === null || text === undefined ? "" : text)
  .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

// "Trees" and/or "Splits" tags of a forest, from how many of its trees are meant for each (see the area endpoints).
const purposeBadges = (row) => {
  const whole = parseInt(row.trees_for_trees || 0, 10);
  const splits = parseInt(row.trees_for_splits || 0, 10);
  const fmt = (n) => new Intl.NumberFormat("de-DE").format(n);
  let html = "";
  if (whole > 0) html += `<span class="purpose-pill purpose-trees" title="${fmt(whole)} tree${whole === 1 ? "" : "s"} sold whole (ERC-721)">Trees</span>`;
  if (splits > 0) html += `<span class="purpose-pill purpose-splits" title="${fmt(splits)} tree${splits === 1 ? "" : "s"} for splits (ERC-1155)">Splits</span>`;
  return html ? `<div class="purpose-badges">${html}</div>` : "";
};

const tourSteps = [
  {
    element: "#areas-filter-buttons",
    popover: {
      title: "All forests vs. my forests",
      description: "Switch between browsing every forest on the platform or just the ones assigned to you."
    }
  },
  {
    element: "#areas-search-group",
    popover: {
      title: "Search",
      description: "Find a forest instantly by its name, owner, or country."
    }
  },
  {
    element: "#areas-datatables",
    popover: {
      title: "Forests",
      description: "Every forest at a glance — click any row to open its full detail page, with its map, growth chart and certificates."
    }
  },
  {
    element: "#areas-claim-col",
    popover: {
      title: "Claim tokens",
      description: "Once a forest's NFT has been minted, claim its available ZCO2 tokens directly from this column."
    }
  }
];

export default {
  name: "AreasList",

  mixins: [createPageTourMixin('areas-list', tourSteps)],

  components: { AreaAddComponent },

  data() {
    return {
      areas: null,
      userId: null,
      config: null,
      stats: {},
      areasTable: null,
      searchTable: null
    };
  },
  computed: {
    ...mapGetters("user", ["getWeb2ActiveAccount"])
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      if (!vm.getWeb2ActiveAccount) {
        await vm.$store.dispatch("user/initWeb2");
      }

      if (!vm.getWeb2ActiveAccount) {
        vm.$router.replace("/");
      }
    });
  },
  beforeDestroy() {
    $(document).off(".areasList");
    if (this.areasTable) this.areasTable.destroy();
  },
  mounted() {
    Config.getConfig()
      .then(config => {
        this.config = config.data;
      })
      .catch(err => {
        console.error("Error loading config:", err);
      });

    let global = this;
    // on document, so namespaced and removed in beforeDestroy (left behind,
    // they pile up on every visit and keep running for dead instances)
    $(document).off(".areasList");
    $(document).on("click.areasList", ".claim-btn", function() {
      const id = $(this).data("id");
      if (id) {
        Swal.fire({
          title: "Are you sure?",
          text: "By claiming, the forest wallet will get the farmed ZCO2 until now",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes"
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "Processing",
              html: "Waiting for confirmations",
              didOpen: () => {
                Swal.showLoading();
              },
              allowOutsideClick: () => !Swal.isLoading()
            });
            Area.claim(id).then((data) => {
              global.loadTableClaimableStats(id);
              const txHash = data?.data?.hash || data?.hash;
              const txLink = (global.config?.tx_url_template && txHash)
                ? `<br><a href="${global.config.tx_url_template.replace("{tx}", txHash)}" target="_blank">Go to explorer</a>`
                : "";
              Swal.fire(
                "Claimed successfully created",
                `You've successfully claimed your ZCO2 tokens.${txLink}`,
                "success");

            }).catch((e) => {
              const errorMsg = e.response?.data?.error?.message 
                || e.response?.data?.message 
                || e.response?.data 
                || e.message 
                || "Claim transaction failed";
              Swal.fire(
                "Error",
                typeof errorMsg === 'object' ? JSON.stringify(errorMsg) : String(errorMsg),
                "error");
            });
          }
        });

      }
    });


    if (this.getWeb2ActiveAccount && this.getWeb2ActiveAccount.role.name === "Authenticated") {
      this.userId = this.getWeb2ActiveAccount.id;
    }


    this.areasTable = $("#areas-datatables").DataTable({
      processing: true,
      serverSide: true,
      language: {
        processing: ""
      },
      // stateSave: true,
      // Wrapping just the "t" (table) token gives the table its own
      // horizontal scrollbar on narrow/tablet screens, instead of the whole
      // page scrolling sideways — the length/pagination row stays outside
      // that scroll area so it's always fully visible.
      dom: "r<\"table-responsive\"t><\"row mt-2\"<\"d-none d-md-block col-md-6\"l><\"col-md-6\"p>>",
      lengthMenu: [[12, 25, 50, 100, 200, 10000000000000], [12, 25, 50, 100, 200, "All"]],
      order: [1, "desc"],
      ajax: {
        url: process.env.VUE_APP_API_URL + "/areas-datatables",
        type: "POST",
        headers: {
          "Authorization": Header.getTokenValue(TokenStorage.get())
        },
        data: (d) => {
          d.userId = this.userId;
        }
      },
      columns: [
        {
          width: 48,
          title: "",
          searchable: false,
          orderable: false,
          data: "image",
          className: "p-0",
          defaultContent: ""
        },
        {
          width: 40,
          title: "ID",
          data: "id",
          defaultContent: ""
        },
        {
          title: "Name",
          data: "name",
          defaultContent: ""
        },
        {
          title: "Forest Owner",
          data: "owner",
          defaultContent: ""
        },
        {
          title: "Country",
          data: "country",
          defaultContent: ""
        },
        {
          title: "Scanned",
          data: "scanned_year",
          defaultContent: ""
        },

        {
          title: "Trees / Ha",
          data: "trees_ha",
          className: "text-right",
          defaultContent: ""
        },

        {
          title: "Trees",
          data: "trees",
          className: "text-right",
          defaultContent: ""
        },

        {
          title: "Yearly",
          data: "theoreticalIncrement",
          className: "text-right",
          width: 110,
          orderable: false,
          searchable: false,
          defaultContent: ""
        },
        {
          title: "Available",
          data: "balance",
          className: "text-right",
          width: 110,
          orderable: false,
          searchable: false,
          defaultContent: ""
        },
        {
          title: '<span id="areas-claim-col">Claim</span>',
          data: "theoreticalIncrement",
          className: "claim-box",
          orderable: false,
          searchable: false,
          width: 120,
          defaultContent: ""
        }
      ],
      columnDefs: [
        {
          targets: 0,
          responsivePriority: 1,
          data: "image",
          // visible: false,
          render: (image, type, all) => {
            // return image;

            if (type === "display") {
              return image ? `<img id="area-img-${all.id}" alt="${all.name}" src="${process.env.VUE_APP_IMAGE_URL + image}">` : "";
            } else {
              return image ? `${process.env.VUE_APP_IMAGE_URL + image}` : "";
            }
          }
        },
        {
          targets: 2,
          data: "name",
          render: (name, type, row) => {
            if (type !== "display") return name;
            return `${escapeHtml(name)}${purposeBadges(row)}`;
          }
        },
        {
          targets: 3,
          data: "owner",
          defaultContent: ""
        },
        {
          targets: 5,
          data: "scanned_year",
          // visible: false,
          render: (scannedYear, type, data) => {

            // const currentYearTheoreticalIncrement = trees ? parseInt(trees) : 0;

            if (type === "display") {
              return `${scannedYear} <span class="badge bg-light text-dark">${new Intl.NumberFormat("de-DE", {}).format(data.scanned_until)} years ago</span>
     `;

            } else {

              return `${data.scanned_until}`;

            }
          }
        },
        {
          targets: 6,
          data: "trees_ha",
          // visible: false,
          render: (treesHa, type) => {

            // const currentYearTheoreticalIncrement = trees ? parseInt(trees) : 0;

            if (type === "display") {
              return `

${new Intl.NumberFormat("de-DE", {
                maximumFractionDigits: 0
              }).format(treesHa)}
     `;

            } else {

              return `${new Intl.NumberFormat("de-DE", {
                maximumFractionDigits: 0
              }).format(treesHa)}`;

            }
          }
        },
        {
          targets: 7,
          data: "trees",
          // visible: false,
          render: (trees, type) => {

            // const currentYearTheoreticalIncrement = trees ? parseInt(trees) : 0;

            if (type === "display") {
              return `

${new Intl.NumberFormat("de-DE", {
                maximumFractionDigits: 0
              }).format(trees)}
     `;

            } else {

              return `${new Intl.NumberFormat("de-DE", {
                maximumFractionDigits: 0
              }).format(trees)}`;

            }
          }
        },
        {
          targets: 8,
          responsivePriority: 8,
          data: "theoreticalIncrement",
          // visible: false,
          render: (theoreticalIncrement, type) => {

            const currentYearTheoreticalIncrement = theoreticalIncrement ? parseFloat(theoreticalIncrement) : 0;

            if (type === "display") {
              return `
        <div class="text-right text-nowrap">
${new Intl.NumberFormat("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(currentYearTheoreticalIncrement)} <span class="cco2-unit">t CO2</span>
        </div>`;

            } else {

              return `${new Intl.NumberFormat("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(currentYearTheoreticalIncrement)} t CO2`;

            }
          }
        },
        {
          targets: 9,
          responsivePriority: 8,
          data: "balance",
          // visible: false,
          render: (balance, type) => {

            balance = balance ? parseFloat(balance) : 0;

            if (type === "display") {
              return `
        <div class="text-right text-nowrap">
${new Intl.NumberFormat("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(balance)} <span class="cco2-unit">t CO2</span>
        </div>`;

            } else {

              return `${new Intl.NumberFormat("de-DE", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }).format(balance)} t CO2`;

            }
          }
        },
        {
          targets: 10,
          responsivePriority: 2,
          data: "theoreticalIncrement",
          // visible: false,
          render: (theoreticalIncrement, type, all) => {
            // const currentYearTheoreticalIncrement = theoreticalIncrement ? parseFloat(theoreticalIncrement) : 0;
            // const claimable = currentYearTheoreticalIncrement / (365 * 24 * 60 * 60) * moment().diff(moment([2022, 0]), 'seconds');


            if (type === "display" && $(`#claimable-${all.id}`).length === 0) {
              if (all.token_id) {
                this.loadTableClaimableStats(all.id);
              }

              return `
              <div style="width: 150px;">
          ${all.token_id ?
                `
            <button id="claimable-${all.id}" data-id="${all.id}" class="btn btn-sm btn-primary btn-block claim-btn" disabled>
            Claim
              <span id="claimable-amount-${all.id}" class="badge badge-light my-1">...</span>
            </button>
          ` :
                `
                <button  class="btn btn-sm btn-secondary btn-block claim-btn" disabled>
            Pending
            </button>
`
              }</div>
              `;

            } else {

              return ``;

            }
          }
        }
      ]
    });

    // The whole row navigates to the area, except the Claim column — that
    // keeps its own click handler above. Delegated on tbody since DataTables
    // replaces the row elements on every sort/page/redraw.
    //
    // A row is a <tr>, not a real <a href>, so the browser's native
    // "open in new tab" gestures (middle-click, ctrl/cmd+click) don't work
    // on it for free — they have to be handled by hand. Middle-click fires
    // as "auxclick" (not "click") in modern browsers, and by default it
    // triggers autoscroll instead, so that has to be suppressed on
    // mousedown for it to actually open a new tab.
    $("#areas-datatables tbody").on("mousedown", "tr", function (e) {
      if (e.which === 2 && !$(e.target).closest(".claim-box").length) {
        e.preventDefault();
      }
    });

    $("#areas-datatables tbody").on("click auxclick", "tr", function (e) {
      if ($(e.target).closest(".claim-box").length) {
        return;
      }
      const rowData = global.areasTable.row(this).data();
      if (!rowData || !rowData.id) return;

      const isMiddleClick = e.type === "auxclick" && e.which === 2;
      const isModifiedClick = e.type === "click" && (e.ctrlKey || e.metaKey);
      if (isMiddleClick || isModifiedClick) {
        window.open(global.$router.resolve(`/areas/${rowData.id}`).href, "_blank");
      } else if (e.type === "click") {
        global.$router.push(`/areas/${rowData.id}`);
      }
    });

    //     }).catch((error) => {
    //   console.log(error)
    // })
  },
  methods: {
    ...mapActions("tokenContract", ["claim"]),
    search() {
      this.areasTable.search(this.searchTable).draw();
    },
    showMyAreas() {
      this.userId = this.getWeb2ActiveAccount.id;
      this.areasTable.ajax.reload();
    },
    showAllAreas() {
      this.userId = null;
      this.areasTable.ajax.reload();
    },
    loadTableClaimableStats(areaId) {
      $("#claimable-" + areaId).prop("disabled", true);
      $("#claimable-amount-" + areaId).html(`...`);

      Area.getClaimable(areaId).then((data) => {
        const claimable = data?.data?.totalCO2 !== undefined ? data.data.totalCO2 : (data?.totalCO2 || 0);
        if (parseFloat(claimable)) {
          $("#claimable-" + areaId).prop("disabled", false);
        } else {

          $("#claimable-" + areaId).prop("disabled", true);

        }

        $("#claimable-amount-" + areaId).html(new Intl.NumberFormat("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(claimable));

      });
    },
    getAreas() {

    }
  }
};
</script>

<style scoped>
::v-deep .purpose-badges {
  margin-top: 4px;
}

::v-deep .purpose-pill {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  line-height: 1;
  padding: 4px 9px;
  border-radius: 999px;
  margin-right: 6px;
  border: 1px solid transparent;
  white-space: nowrap;
}

::v-deep .purpose-trees {
  background: rgba(72, 187, 120, 0.16);
  color: #1f7a4c;
  border-color: rgba(72, 187, 120, 0.6);
}

::v-deep .purpose-splits {
  background: rgba(66, 153, 225, 0.16);
  color: #2b6cb0;
  border-color: rgba(66, 153, 225, 0.6);
}

[data-theme="dark"] ::v-deep .purpose-trees {
  color: #7be0ae;
}

[data-theme="dark"] ::v-deep .purpose-splits {
  color: #86c4ff;
}

::v-deep .add-forest-modal-body {
  padding: 24px 28px;
  max-height: 75vh;
}
</style>
